import type { VisualSize } from '$lib/types/Components/SharedTypes';

export const LIST_ITEM_VISUAL_SIZE_HORIZONTAL_MAP: Record<VisualSize, number> = {
    small: 48,
    medium: 64,
    large: 80,
    xLarge: 96,
};

export const LIST_ITEM_VISUAL_SIZE_VERTICAL_MAP: Record<VisualSize, number> = {
    small: 48,
    medium: 120,
    large: 192,
    xLarge: 264,
};

export const LIST_ITEM_EMOJI_PADDING_MAP: Record<VisualSize, number> = {
    small: 8,
    medium: 24,
    large: 44,
    xLarge: 68,
};

export const TEXT_SIZE_MAP: Record<'small' | 'medium', string> = {
    small: '16px',
    medium: '19px',
};
